enum OptionalAccessSection {
  MARKETPLACE = "marketplace",
}

export default OptionalAccessSection;